<template>
    <main class="o-site-main">
        <Head>
            <Title>{{ pageData.seo.title }}</Title>
            <Meta name="description" :content="pageData.seo.metaDesc" />
            <Meta name="og:title" :content="pageData.seo.opengraphTitle" />
            <Meta name="og:description" :content="pageData.seo.opengraphDescription" />
            <Meta name="og:image" :content="pageData.seo.opengraphImage.sourceUrl" v-if="pageData.seo.opengraphImage" />
            <Meta name="twitter:title" :content="pageData.seo.twitterTitle" />
            <Meta name="twitter:description" :content="pageData.seo.twitterDescription" />
            <Meta
                name="twitter:image"
                :content="pageData.seo.twitterImage.sourceUrl"
                v-if="pageData.seo.twitterImage" />
        </Head>

        <component
            v-once
            v-for="(component, index) in pageData.components.components"
            :is="$formatComponentName(component.fieldGroupName, 'Page')"
            v-bind="component"
            :key="index" />
    </main>
</template>

<script setup lang="ts">
    import pageQuery from "~/queries/page";
    const query = gql(pageQuery);
    const pageData = useState("pageData", () => null);
    const route = useRoute();
    const modifiedPath = route.path.replace("/server", "") == "" ? "/" : route.path.replace("/server", "");

    const variables = {
        slug: modifiedPath,
    };

    useStructuredData(modifiedPath);


    const getPagedata = async () => {
        try {
            const { data, error } = await useAsyncQuery(query, { ...variables });

            // Validate data structure
            if (!data?.value?.nodeByUri?.title) {
                throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
            }
            
            // Assign the resolved value to pageData
            pageData.value = data.value.nodeByUri;
        } catch (err) {
            // Re-throw the error with a proper status code and message
            throw createError({
                statusCode: err.statusCode || 500,
                statusMessage: err.statusMessage || "An unexpected error occurred",
            });
        }
    };

    await getPagedata();
</script>
